import { render, staticRenderFns } from "./Keyboards.vue?vue&type=template&id=a6985c72&scoped=true"
import script from "./Keyboards.vue?vue&type=script&lang=js"
export * from "./Keyboards.vue?vue&type=script&lang=js"
import style0 from "./Keyboards.vue?vue&type=style&index=0&id=a6985c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6985c72",
  null
  
)

export default component.exports